import Icon from "~/components/shared/Icon";

import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from "~/components/shared/PopoverNext";
import Examples from "~/components/pipeline/New/ExamplePicker/Examples";

export default function ExamplePicker({
  examplesPath,
  minimal,
}: {
  examplesPath: string;
  minimal?: boolean;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild={true}>
        {minimal ? (
          <button className="flex shrink-0 items-center gap-1 rounded-sm font-medium text-purple-600">
            Or try out an example Pipeline
            <Icon icon="down-triangle" className="size-2" />
          </button>
        ) : (
          <button className="flex h-8 shrink-0 items-center gap-1 rounded-sm bg-purple-100 px-2.5 font-medium text-purple-600">
            Try an example
            <Icon icon="down-triangle" className="size-2" />
          </button>
        )}
      </PopoverTrigger>

      <PopoverPortal>
        <PopoverContent
          alignOffset={0}
          align="end"
          data-testid="example-picker-popover"
          className="max-h-96 w-80 overflow-y-auto p-0"
        >
          <Examples examplesPath={examplesPath} />
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
}
